import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import { useAwaitResponse } from "../../../Api/HttpRequestHelpers";
import { SignupClient } from "../../../Api/client/CompetitionClient";
import { StartlistRow } from "../../../Api/dto/StartlistDto";

export function Startlist() {
  const { competitionTag } = useParams() as { competitionTag: string };

  const [startlist, isLoadingStartlist] = useAwaitResponse(
    null,
    () => SignupClient.getStartlist(competitionTag),
    (response) => response.body ?? null
  );

  if (isLoadingStartlist) {
    return <Spinner size={"xl"} colorScheme="blue" />;
  }

  const orderDisciplineMap = new Map<string, number>();
  const disciplineStartlistMap = new Map<string, StartlistRow[]>();

  startlist?.rows.forEach((row) => {
    orderDisciplineMap.set(row.disciplineName, row.disciplineDisplayOrder);
    if (!disciplineStartlistMap.has(row.disciplineName)) {
      disciplineStartlistMap.set(row.disciplineName, []);
    }
    disciplineStartlistMap.get(row.disciplineName)!.push(row);
  });

  const orderedDisciplines = Array.from(orderDisciplineMap.entries())
    .sort((e1, e2) => e1[1] - e2[1])
    .map((e) => e[0]);

  const rowSortingRules = (a: StartlistRow, b: StartlistRow) => {
    if (a.startnumber && b.startnumber) {
      return a.startnumber - b.startnumber;
    }
    if (a.groupName && b.groupName) {
      return a.groupName.localeCompare(b.groupName);
    } else if (a.firstname) {
      if (b.firstname && a.firstname !== b.lastName) {
        return a.firstname.localeCompare(b.firstname);
      } else if (a.lastName && b.lastName) {
        return a.lastName.localeCompare(b.lastName);
      }
    }
    return 0;
  };

  return (
    <>
      <Breadcrumb mb={8}>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="../../..">
          ...
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="..">
            {competitionTag}
          </BreadcrumbLink>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>Startlista </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <div>
        <Heading as={"h2"} size={"lg"} marginTop={"20pt"} marginBottom={"10px"}>
          {`Startlista ${startlist?.competitionName}`}
        </Heading>
        <Text
          fontWeight={"bold"}
          marginBottom={"20px"}
        >{`Totalt ${startlist?.rows.length} personer anmälda`}</Text>
      </div>

      <Table key={"table0"} marginBottom={"100px"}>
        <Thead key={"thead0"}>
          <Tr key={"header0"}>
            <Th key={"nr0"}>Nr</Th>
            <Th key={"class0"}>Klass</Th>
            <Th key={"name0"}>Namn</Th>
            <Th key={"group0"}>Klubb/Lag</Th>
            <Th key={"birthyear0"}>Födelseår</Th>
          </Tr>
        </Thead>

        {orderedDisciplines.map((discipline, i) => {
          return (
            <Tbody key={"tbody" + i}>
              {(disciplineStartlistMap.get(discipline) || [])
                .sort(rowSortingRules)
                .map((row, j) => {
                  return (
                    <>
                      {j === 0 ? (
                        <Tr key={"itemheading" + discipline + j}>
                          <Td
                            key={"itemheadingcontent" + discipline + j}
                            colSpan={5}
                            textAlign="left"
                            background={"blue.200"}
                          >
                            <Text fontWeight="bold">{discipline}</Text>
                            <Text fontStyle={"italic"}>
                              Anmälda:{" "}
                              {disciplineStartlistMap.get(discipline)?.length ??
                                0}{" "}
                              st
                            </Text>
                          </Td>
                        </Tr>
                      ) : null}
                      <Tr key={row.firstname + row.birthYear + i + j}>
                        <Td key={"cell0" + row.firstname + row.birthYear}>
                          {row.startnumber}
                        </Td>
                        <Td
                          key={"cell1" + row.firstname + row.birthYear + i + j}
                        >{`${discipline}`}</Td>
                        <Td
                          key={"cell2" + row.firstname + row.birthYear + i + j}
                        >
                          {row.firstname + " " + row.lastName}
                        </Td>
                        <Td
                          key={"cell3" + row.firstname + row.birthYear + i + j}
                        >
                          {row.groupName ?? row.sportTeam}
                        </Td>
                        <Td
                          key={"cell4" + row.firstname + row.birthYear + i + j}
                        >
                          {row.birthYear}
                        </Td>
                      </Tr>
                    </>
                  );
                })}
            </Tbody>
          );
        })}
      </Table>
    </>
  );
}
